<!--
    描述：字典管理页面
    时间：2020-04-27
    Created by zwh
-->
<template>
	<div class="w-table-layout w-table-page">
		<transition name="fade"
					mode="out-in">
			<!-- 列表 -->
			<div class="list-wrap w-table-content"
				 ref="tableContent"
				 key="list">
				<el-table :data="tableObj.tableData"
						  row-key="id"
						  v-loading="tableObj.loading"
						  ref="objTable"
						  :height="tableObj.tableH"
						  border
						  highlight-current-row
						  :tree-props="{children: 'children'}">
					<el-table-column type="index"
									 align="center"
									 width="50"></el-table-column>
					<el-table-column prop="value"
									 label="字典编号"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
					<el-table-column prop="sname"
									 label="字典名称"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
					<el-table-column prop="sort"
									 label="排序"
									 align="center"
									 show-overflow-tooltip
									 width="100"></el-table-column>
					<el-table-column prop="parentName"
									 label="父级名称"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
					<el-table-column prop="updateUserName"
									 label="更新人"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
					<el-table-column prop="updateDate"
									 label="更新时间"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
					<el-table-column label="操作"
									 align="center"
									 show-overflow-tooltip
									 min-width="90">
						<template slot-scope="scope">
							<el-button size="mini"
									   icon="el-icon-circle-plus"
									   title="新增"
                                       v-if="roleBtns.includes('dict_add')"
									   type="text"
									   @click="doClick(scope.row,'add')"></el-button>
							<el-button size="mini"
									   icon="el-icon-edit"
									   title="编辑"
									   type="text"
                                       v-if="roleBtns.includes('dict_edit')"
									   @click="doClick(scope.row,'edit')"></el-button>
							<el-button v-if="!scope.row.children && roleBtns.includes('dict_delete')"
									   size="mini"
									   icon="el-icon-delete"
									   title="删除"
									   type="text"
									   @click="doClick(scope.row,'delete')"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</transition>

		<!-- 底部分页 -->
		<div class="w-table-footer">
			<el-pagination @size-change="handleSizeChange"
						   @current-change="handleCurrentChange"
						   :current-page="tableObj.currentPage"
						   :page-sizes="tableObj.pageList"
						   :page-size="tableObj.pageSize"
						   layout="total, sizes, prev, pager, next, jumper"
						   :total="tableObj.total">
			</el-pagination>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">

			<!-- 弹窗组件 -->
			<addDialog v-if="dialogObj.visible"
					   :transObj="transObj"
					   ref="addDialog"
					   @on-success="onSuccess"></addDialog>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.type !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getTreeTablePageList, deleteById } from '@/api/modules/dict.js'
import addDialog from './add_dialog'
export default {
	components: { addDialog },
	props: {},
	data() {
		return {
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: ''
			},
			searchObj: '',
			tableObj: {
				loading: false,
				pageSize: 10,
				currentPage: 1,
				total: 0,
				tableH: 0,
				tableData: [],
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			}
		}
	},
	created() {
		this.getTablePageList()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	methods: {
		searchTablePageList(searchObj) {
			this.searchObj = searchObj
			this.getTablePageList()
		},
		getTablePageList() {
			let that = this
			let param = {}
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			param.sname = this.searchObj.sname
			getTreeTablePageList(param).then(res => {
				if (res.operationCode == 1) {
					that.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},
		//新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			let that = this
			if (type === 'add' || type === 'addGroup') {
				that.transObj.mode = 'add'
				that.transObj.id = ''
				that.transObj.type = type
				if (obj != '') {
					that.transObj.parentId = obj.id
					that.transObj.parentName = obj.sname
				} else {
					that.transObj.parentId = '0'
					that.transObj.parentName = ''
				}
				this.dialogObj.title = '新增字典'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				that.transObj.mode = 'edit'
				if (obj.parentId == 0) that.transObj.type = 'editGroup'
				else that.transObj.type = 'edit'
				this.transObj.id = obj.id
				this.transObj.parentId = ''
				this.transObj.parentName = ''
				this.dialogObj.title = '编辑字典'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				that.transObj.mode = 'delete'
				this.delete(obj)
			}
		},
		delete(obj) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = { id: obj.id }
				deleteById(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getTablePageList()
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTablePageList()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getTablePageList()
		},
		doSave() {
			this.$refs.addDialog.doSave()
		},
		onSuccess() {
			this.dialogObj.visible = false
			this.getTablePageList()
		},
		handleClose() {}
    },
    computed: {
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    }
}
</script>

<style scoped lang="less">
</style>